import { render, staticRenderFns } from "./AssetsPersonsReport.vue?vue&type=template&id=548bbe60"
import script from "./AssetsPersonsReport.vue?vue&type=script&lang=js"
export * from "./AssetsPersonsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports